import { useState } from 'react';
import { Button } from '../../../components/form/button';
import { PurchaseOrder, PurchaseOrderStatus } from '../../../clients/quipli-service/purchase-order/purchase-order';
import { ApprovePurchaseOrder } from './approve-purchase-order';
import { toast } from '../../../util/toasts';
import { useAdmin } from '../../../hooks/use-admin-context';
import { ReceivePurchaseOrder } from '../components/receive-purchase-order/receive-purchase-order';
import { Dropdown } from '../../../components/dropdown/dropdown';
import Icon from '../../../components/icons/icon';
import { Typography } from '../../../components/typography/typography';
import { CancelPurchaseOrder } from './cancel-purchase-order';

type PurchaseOrderStatusTransitionButton = 'approve' | 'receive' | 'cancel';

export const PurchaseOrderStatusTransitionButtons = ({
  order,
  isDisabled,
  reload,
  hideTransitions = [],
}: {
  order: PurchaseOrder;
  isDisabled: boolean;
  reload: () => void;
  hideTransitions?: PurchaseOrderStatusTransitionButton[];
}) => {
  const { hasPermissions } = useAdmin();
  const [activeStatusModal, setActiveStatusModal] = useState<PurchaseOrderStatusTransitionButton | undefined>();
  const showCancel = ![PurchaseOrderStatus.Cancelled, PurchaseOrderStatus.Received].includes(order.status);

  return order ? (
    <div className="order-status-transitions w-full">
      <div className="flex justify-between gap-x-[12px] px-[0.6rem] sm:px-0 [&>*]:grow md:[&>*]:grow-0">
        {!hideTransitions.includes('approve') &&
          order.status === PurchaseOrderStatus.Requested &&
          hasPermissions('Approve Purchase Orders') && (
            <Button
              className="button button-yellow"
              onClick={() => setActiveStatusModal('approve')}
              disabled={isDisabled}
            >
              Approve Order
            </Button>
          )}

        {!hideTransitions.includes('receive') && order.status === PurchaseOrderStatus.Approved && (
          <Button
            className="button button-primary"
            onClick={() => setActiveStatusModal('receive')}
            disabled={isDisabled}
          >
            Receive
          </Button>
        )}
        {showCancel && (
          <div className="!grow-0">
            <Dropdown
              trigger={() => (
                <Button className="icon-button">
                  <Icon icon="DotsVertical" size="medium" />
                </Button>
              )}
            >
              {showCancel && (
                <div onClick={() => !isDisabled && setActiveStatusModal('cancel')}>
                  <Typography type="text-sm" className="text-quipli-black-800">
                    Cancel Purchase Order
                  </Typography>
                </div>
              )}
            </Dropdown>
          </div>
        )}
      </div>

      {activeStatusModal === 'approve' && (
        <ApprovePurchaseOrder
          order={order}
          onCancel={() => setActiveStatusModal(undefined)}
          onComplete={() => {
            reload();
            toast('Purchase order approved');
            setActiveStatusModal(undefined);
          }}
        />
      )}

      {activeStatusModal === 'receive' && (
        <ReceivePurchaseOrder
          purchaseOrder={order}
          onCancel={() => setActiveStatusModal(undefined)}
          onComplete={() => {
            reload();
            toast('Purchase order received');
            setActiveStatusModal(undefined);
          }}
        />
      )}

      {activeStatusModal === 'cancel' && (
        <CancelPurchaseOrder
          purchaseOrder={order}
          onCancel={() => setActiveStatusModal(undefined)}
          onComplete={() => {
            reload();
            toast('Purchase order cancelled');
            setActiveStatusModal(undefined);
          }}
        />
      )}
    </div>
  ) : (
    <></>
  );
};
